document.querySelectorAll('[data-filter]').forEach(button=>button.addEventListener('click',()=>{const section=button.closest('section');section.querySelectorAll('[data-filter]').forEach(b=>{b.classList.toggle('selected',b===button);b.setAttribute('aria-pressed',String(b===button))});section.querySelectorAll('[data-language]').forEach(card=>{card.hidden=button.dataset.filter!=='all'&&card.dataset.language!==button.dataset.filter})}));
function initCarousels(root=document){
  root.querySelectorAll('[data-carousel]').forEach(carousel=>{
    if(carousel.dataset.initialized)return;
    carousel.dataset.initialized='true';
    const track=carousel.querySelector('[data-carousel-track]');
    const slides=[...track.children];
    const thumbs=[...carousel.querySelectorAll('[data-carousel-index]')];
    const status=carousel.querySelector('[data-carousel-status]');
    let current=0,frame;
    const update=()=>{
      current=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/track.clientWidth)));
      thumbs.forEach((button,index)=>button.setAttribute('aria-pressed',String(index===current)));
      if(status)status.textContent=`${current+1} / ${slides.length}`;
    };
    const go=index=>{
      index=(index+slides.length)%slides.length;
      track.scrollTo({left:index*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    };
    carousel.querySelector('[data-carousel-prev]')?.addEventListener('click',()=>go(current-1));
    carousel.querySelector('[data-carousel-next]')?.addEventListener('click',()=>go(current+1));
    thumbs.forEach((button,index)=>button.addEventListener('click',()=>go(index)));
    track.addEventListener('keydown',event=>{
      if(event.key==='ArrowLeft'||event.key==='ArrowRight'){
        event.preventDefault();go(current+(event.key==='ArrowRight'?1:-1));
      }
    });
    track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update)},{passive:true});
    new ResizeObserver(()=>{track.scrollTo({left:current*track.clientWidth,behavior:'instant'})}).observe(track);
  });
}
initCarousels();
document.addEventListener('shopify:section:load',event=>initCarousels(event.target));
